// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

const config = {
  // 'Inter Fallback' (assets/style.css): Arial sized to Inter, so text doesn't reflow when Inter loads.
  fontFamily: `'Inter', 'Inter Fallback', sans-serif`,
  showPageTitleAndBreadcrumbs: false
};

export default config;
